import { render } from "./special.vue?vue&type=template&id=5a1b50e7&scoped=true"
import script from "./special.vue?vue&type=script&lang=js"
export * from "./special.vue?vue&type=script&lang=js"

import "./special.vue?vue&type=style&index=0&id=5a1b50e7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1b50e7"]])

export default __exports__